module.exports = __webpack_public_path__ + "static/media/landing.8cef858e.gif";